<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-detail" @click="open">
            <i v-if="client.gender === 'male'" class="fa fa-lg fa-mars icon-male" aria-hidden="true" title="muž"></i>
            <i v-else-if="client.gender === 'female'" class="fa fa-lg fa-venus icon-female" aria-hidden="true" title="žena"></i>
            <i v-else="" class="fa fa-lg fa-genderless icon-genderless" aria-hidden="true" title="neznámé pohlaví"></i>
            <span style="border-bottom: 1px dotted gray">
                <span><b>{{ client.full_name }}</b></span>
                <span class="separator">|</span>
                <span v-if="client.insurance_number !== null">ČP: <b>{{ client.insurance_number }}</b></span>
                <span v-else-if="client.p_i_n !== false">RČ: <b>{{ client.p_i_n }}</b></span>
                <span v-else="" class="text-danger"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Chybí RČ / ČP</span>
                <span class="separator">|</span>
                <span>{{ client.age_with_suffix }} ({{ client.birth_date }})</span>
                <template v-if="client.employer">
                        <span class="separator">|</span>
                        <span>{{ client.employer }}</span>
                </template>
            </span>
        </span>
        <template slot="popover">
    <div class="container tooltip_container tooltip_2_col" v-if="!citizenshipPending">
        <div class="row tooltip_header">
            <div class="col-sm-2 text-left">
                <button class="btn btn-sm btn-outline-secondary" data-testid="client-detail-edit" @click="edit" v-if="editMode === false"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> upravit</button>
                <button class="btn btn-sm btn-outline-secondary" data-testid="client-detail-back" @click="view" v-else=""><i class="fa fa-arrow-left" aria-hidden="true"></i> zpět</button>
            </div>
            <div class="col-sm-8" v-if="editMode === true">Úprava klienta</div>
            <div class="col-sm-8" v-else="">Detail klienta</div>
            <div class="col-sm-2"></div>
        </div>
        <div class="row"  v-if="editMode === true">
            <div class="col-sm-12 tooltip_body text-left">
                <form @submit.prevent="submitForm">
                    <div class="row justify-content-center">
                        <div class="form-group col-md-2">
                            <label for="titlesPreName">Tituly před jménem:</label>
                            <input v-model="clientForm.title_before" type="text" class="form-control" data-testid="client-detail-title-before" aria-describedby="titlesPreNameHelp" id="titlesPreName">
                            <small id="titlesPreNameError" class="form-text text-danger"></small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="firstname">Jméno:</label>
                            <input v-model="clientForm.first_name" type="text" class="form-control" data-testid="client-detail-first-name" aria-describedby="firstnameHelp" id="firstname">
                            <small id="firstnameError" class="form-text text-danger" v-if="clientError.firstname">{{ clientError.firstname.message }}</small>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="lastname">Příjmení:</label>
                            <input v-model="clientForm.last_name" type="text" class="form-control" data-testid="client-detail-last-name" aria-describedby="lastnameHelp" id="lastname">
                            <small id="lastnameError" class="form-text text-danger" v-if="clientError.lastname">{{ clientError.lastname.message }}</small>
                        </div>
                        <div class="form-group col-md-2">
                            <label for="titlesAfterName">Tituly za jménem:</label>
                            <input v-model="clientForm.title_after" type="text" class="form-control" data-testid="client-detail-title-after" aria-describedby="titlesAfterNameHelp" id="titlesAfterName">
                            <small id="titlesAfterNameError" class="form-text text-danger"></small>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="form-group col-md-12">
                            <label for="citizenshipGov">Státní příslušnost (občanství):</label>
                            <div class="input-group">
                                <select v-model="clientForm.citizenship.id" class="form-control" data-testid="client-detail-citizenship" aria-describedby="citizenshipGovHelp" id="citizenshipGov">
                                    <option v-for="c in citizenship" v-bind:value="c.id">{{ c.name_cz }} - {{ c.code }} - {{ c.name_en }}</option>
                                </select>
                                <small id="citizenshipError" class="form-text text-danger" v-if="clientError.citizenship">{{ clientError.citizenship.message }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="form-group col-md-6">
                            <label for="personalid">Rodné číslo:</label>
                            <input v-model="clientForm.p_i_n" type="text" class="form-control" data-testid="client-detail-pin" aria-describedby="personalidHelp" id="personalid">
                            <small id="personalidError" class="form-text text-danger" v-if="clientError.pin">{{ clientError.pin.message }} {{ parsePinMessage }}</small>
                            <template v-if="decodePinWarning !== null">
                              <div v-for="(warning, index) in decodePinWarning">
                                <template v-if="index === 'duplicate' && warning.clients.length > 1">
                                  <small class="form-text text-danger">{{ warning.text }}</small>
                                  <small v-for="client in warning.clients" class="form-text text-danger"> - {{ client.full_name }}</small>
                                </template>
                                <template v-else-if="index !== 'duplicate'">
                                  <small class="form-text text-danger">{{ warning.text }}</small>
                                </template>
                              </div>
                            </template>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="insuranceNumber">Číslo pojištěnce:</label>
                            <input v-model="clientForm.insurance_number" type="text" class="form-control" data-testid="client-detail-insurance-number" aria-describedby="insuranceNumberHelp" id="insuranceNumber">
                            <small id="insuranceNumberError" class="form-text text-danger" v-if="clientError.insurancenumber">{{ clientError.insurancenumber.message }}</small>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="form-group col-md-6">
                            <label for="gender">Pohlaví:</label>
                            <div class="input-group">
                                <select v-model="clientForm.gender" class="form-control" data-testid="client-detail-gender" aria-describedby="genderHelp" id="gender">
                                    <option value="male">muž</option>
                                    <option value="female">žena</option>
                                    <option value="unknown">nezjištěno</option>
                                </select>
                                <small id="genderError" class="form-text text-danger" v-if="clientError.gender">{{ clientError.gender.message }}</small>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="birthdate">Datum narození:</label>
                            <input v-model="clientForm.birth_date" type="text" class="form-control" data-testid="client-detail-birth-date" aria-describedby="birthdateHelp" id="birthdate">
                            <small id="birthdateError" class="form-text text-danger" v-if="clientError.birthdate">{{ clientError.birthdate.message }}</small>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="form-group col-md-6">
                            <label for="employer">Zaměstnavatel/firma:</label>
                            <input v-model="clientForm.employer" type="text" class="form-control" data-testid="client-detail-employer" aria-describedby="firstnameHelp" id="employer">
                            <small id="employerError" class="form-text text-danger" v-if="clientError.employer">{{ clientError.employer.message }}</small>
                        </div>
                        <div class="form-group col-md-6">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="form-group col-md-12 text-center">

                            <button v-if="decodePinPending" class="btn btn-primary disabled" disabled="disabled"><i class="fa fa-spinner fa-pulse fa-fw"></i> Čekám</button>
                            <button v-else-if="clientPending === false" type="submit" class="btn btn-primary" data-testid="client-detail-save">Uložit změny</button>
                            <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row"  v-else="">
                <table class="table table_labeled table-bordered" data-testid="client-detail-table">
                    <tr>
                        <td class="w-25"><span class="td_label">tituly před jménem</span>{{ client.title_before | neverEmpty }}</td>
                        <td class="w-25"><span class="td_label">jméno</span>{{ client.first_name | neverEmpty }}</td>
                        <td class="w-25"><span class="td_label">příjmení</span>{{ client.last_name | neverEmpty }}</td>
                        <td class="w-25"><span class="td_label">tituly za jménem</span>{{ client.title_after | neverEmpty }}</td>
                    </tr>
                    <tr>
                        <td colspan="4"><span class="td_label">státní příslušnost (občanství)</span>{{ client.citizenship ? client.citizenship.name_cz : '-' }}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><span class="td_label">rodné číslo</span>{{ client.p_i_n | neverEmpty }}</td>
                        <td colspan="2"><span class="td_label">číslo pojištěnce</span>{{ client.insurance_number | neverEmpty }}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><span class="td_label">pohlaví</span>{{ client.gender | genderToCS }}</td>
                        <td colspan="2"><span class="td_label">datum narození</span>{{ client.birth_date | neverEmpty }}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><span class="td_label">zaměstnavatel/firma:</span>{{ client.employer | neverEmpty }}</td>
                        <td colspan="2"><span class="td_label"></span></td>
                    </tr>
                </table>
        </div>
    </div>
    </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        editMode: false,
        parsePinMessage: '',
        clientDone: false,
        clientForChange: false,
        clientForm: {
          p_i_n: false
        },
        isOpen: false,
        citizenshipPending: true,
        citizenshipError: true,
        insurance: {
          insurance_company: null
        },
        insurancePending: false,
        clientError: false,
        clientPending: false,
        birthDateCalculated: false,
        decodePinPending: false,
        decodePinWarning: false,
        decodePinError: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      open () {
        this.isOpen = true
        this.editMode = false
      },
      close () {
        this.isOpen = false
      },
      submitForm () {
        this.clientForUpdate = JSON.parse(JSON.stringify(this.clientForm, this.replacer))
        delete this.clientForUpdate['email_address']
        delete this.clientForUpdate['phone_number']
        delete this.clientForUpdate['client_auth']
        delete this.clientForUpdate['address']
        delete this.clientForUpdate['gdpr_consent']
        this.clientForUpdate.citizenship = this.clientForm.citizenship.id
        this.putClient(this.clientForUpdate)
      },
      edit () {
        this.clientForm = JSON.parse(JSON.stringify(this.client))
        this.clientForm.health_insurance = null
        this.clientForm.membership = null
        this.clientForm.address = null
        this.editMode = true
      },
      view () {
        this.editMode = false
      }
    },
    watch: {
      isOpen (val) {
        if (val === true) {
          // this.clientForm = JSON.parse(JSON.stringify(this.client))
          this.getCitizenship()
          this.decodePinPending = false
          this.clientError = false
        } else {
          this.citizenshipPending = true
        }
      },
      'clientForm.p_i_n': function (val) {
        if (val) {
          this.clientForm.p_i_n = val.replace(/\D/g, '')

          if (val !== this.clientForm.p_i_n) {
            return
          }

          if (this.clientForm.citizenship.id === 1) {
            if (val.length < 9) {
              this.parsePinMessage = 'příliš krátké'
              this.clientForm.gender = 'unknown'
              this.clientForm.birth_date = ''
            } else if (val.length > 10) {
              this.parsePinMessage = 'příliš dlouhé'
              this.clientForm.gender = 'unknown'
              this.clientForm.birth_date = ''
            } else {
              this.parsePinMessage = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám'
              setTimeout(() => {
                this.decodePIN(this.clientForm.p_i_n)
              }, 500)
            }
          } else {
            this.birthDateCalculated = false
          }
        }
      },
      'clientForm.insurance_number': function (val) {
        if (val) {
          this.clientForm.insurance_number = val.replace(/\D/g, '')
        }
      },
      'clientForm.citizenship.id': function (val) {
        if (val !== 1) {
          this.birthDateCalculated = false
        } else {
          if (this.clientForm.p_i_n) {
            if (this.clientForm.p_i_n.length < 9) {
              this.parsePinMessage = 'příliš krátké'
              this.clientForm.gender = 'unknown'
              this.clientForm.birth_date = ''
            } else if (this.clientForm.p_i_n.length > 10) {
              this.parsePinMessage = 'příliš dlouhé'
              this.clientForm.gender = 'unknown'
              this.clientForm.birth_date = ''
            } else {
              this.parsePinMessage = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám'
              setTimeout(() => {
                this.decodePIN(this.clientForm.p_i_n)
              }, 500)
            }
          }
        }
      },
      clientDone (val) {
        if (val === true) {
          this.$emit('reload-client', true)
          this.$emit('reload-client', false)
          this.clientDone = false
          this.close()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }

    /*modal insurance*/

    tr.valid_line {
        font-weight: bold;
    }

    .modal_default {
        overflow: visible !important;
    }

    table.table td {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientDetail.vue?6d098f9e